<div class="network-overview-main">
    <div class="row">
        <div class="col-xl-3">
          <div class="card mb-4">
            <!-- <p class="border-bottom p-3 text-center">2:58 AM PDF</p> -->
            <img src="assets/images/network-overview-img/store.png" alt="" class="store-img" />
            <div class="card-body h-100">
                <h5 class="card-title">{{ host?.reportedState?.name }}</h5>
                <p>{{ host?.reportedState?.hardware?.shortname }} {{ host?.reportedState?.hardware?.firmwareVersion }}</p>
                <div class="view d-flex align-items-center justify-content-between flex-wrap">
                    <div>
                        <a href="" class="color-0e65e9">view release notes </a>
                    </div>
                    <div>
                        <a href="" class="color-0e65e9">submit support ticket</a>
                    </div>
                </div>
                <div class="wan-ip d-flex align-items-center mt-3 justify-content-between flex-wrap">
                    <div>
                        <p>WAN IP(part-5)</p>
                    </div>
                    <div>
                        <p>{{ ipAddresses?.[0] || host?.reportedState?.ip || "N/A" }}</p>
                    </div>
                </div>
                <div class="gateway d-flex align-items-center justify-content-between flex-wrap">
                    <div>
                        <p>Gateway IP</p>
                    </div>
                    <div>
                        <p>{{ ipAddresses?.[1] || "N/A" }}</p>
                    </div>
                </div>
                <div
                    class="system d-flex align-items-center justify-content-between flex-wrap border-bottom border-top py-3">
                    <div>
                        <h5 class="mb-0 f-16">Latest Backup Time</h5>
                    </div>
                    <div>
                        <p class="mb-0">{{ convertDate(host?.latestBackupTime) }}</p>
                    </div>
                </div>
                <div class="internet d-flex align-items-center justify-content-between flex-wrap mt-3">
                    <div>
                        <p>Internet</p>
                    </div>
                    <div>
                        <div class="d-flex gap-3 align-items-center flex-wrap">
                            <!-- <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="gray"
                                class="bi bi-circle-fill" viewBox="0 0 16 16">
                                <circle cx="8" cy="8" r="8" />
                            </svg> -->
                            <p class="mb-0">{{ host?.statistics?.ispInfo?.name || "N/A" }}</p>
                        </div>
                    </div>
                </div>
                <div class="uptime d-flex align-items-center justify-content-between flex-wrap">
                    <div>
                        <p>Uptime</p>
                    </div>
                    <div>
                        <p class="color-6bd700 ">{{ (host?.statistics?.percentages?.wanUptime | number : "1.0-2") || 0 }}%</p>
                    </div>
                </div>
                <div class="d-flex align-items-center justify-content-between flex-wrap">
                    <div>
                        <p class="mb-0">Activity</p>
                    </div>
                    <div class="d-flex gap-3 align-items-center flex-wrap">
                        <div class="d-flex align-items-center flex-wrap">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="#25abe9"
                                class="bi bi-arrow-down" viewBox="0 0 16 16">
                                <path fill-rule="evenodd"
                                    d="M8 1a.5.5 0 0 1 .5.5v11.793l3.146-3.147a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 .708-.708L7.5 13.293V1.5A.5.5 0 0 1 8 1" />
                            </svg>
                            <p class="mb-0 color-25abe9">0.04 Mpbs</p>
                        </div>
                        <div class="d-flex align-items-center flex-wrap">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="#a355ec"
                                class="bi bi-arrow-up" viewBox="0 0 16 16">
                                <path fill-rule="evenodd"
                                    d="M8 15a.5.5 0 0 0 .5-.5V2.707l3.146 3.147a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 1 0 .708.708L7.5 2.707V14.5a.5.5 0 0 0 .5.5" />
                            </svg>
                            <p class="mb-0 color-a355ec">0.04 Mpbs</p>
                        </div>
                    </div>
                </div>
                <div class="d-flex align-items-center justify-content-between mt-3 border-bottom pb-3 flex-wrap">
                    <div class="d-flex align-items-center gap-2 flex-wrap">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                            class="bi bi-microsoft" viewBox="0 0 16 16">
                            <path
                                d="M7.462 0H0v7.19h7.462zM16 0H8.538v7.19H16zM7.462 8.211H0V16h7.462zm8.538 0H8.538V16H16z" />
                        </svg>
                        <p class="mb-0 color-808080">22 ms</p>
                    </div>
                    <div class="d-flex align-items-center gap-2 flex-wrap">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                            class="bi bi-google" viewBox="0 0 16 16">
                            <path
                                d="M15.545 6.558a9.4 9.4 0 0 1 .139 1.626c0 2.434-.87 4.492-2.384 5.885h.002C11.978 15.292 10.158 16 8 16A8 8 0 1 1 8 0a7.7 7.7 0 0 1 5.352 2.082l-2.284 2.284A4.35 4.35 0 0 0 8 3.166c-2.087 0-3.86 1.408-4.492 3.304a4.8 4.8 0 0 0 0 3.063h.003c.635 1.893 2.405 3.301 4.492 3.301 1.078 0 2.004-.276 2.722-.764h-.003a3.7 3.7 0 0 0 1.599-2.431H8v-3.08z" />
                        </svg>
                        <p class="mb-0 color-808080">60 ms</p>
                    </div>
                    <div class="d-flex align-items-center gap-2 flex-wrap">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                            class="bi bi-cloud-fill" viewBox="0 0 16 16">
                            <path
                                d="M4.406 3.342A5.53 5.53 0 0 1 8 2c2.69 0 4.923 2 5.166 4.579C14.758 6.804 16 8.137 16 9.773 16 11.569 14.502 13 12.687 13H3.781C1.708 13 0 11.366 0 9.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383" />
                        </svg>
                        <p class="mb-0 color-808080">23ms</p>
                    </div>
                </div>
                <div class="d-flex align-items-center justify-content-between mt-2 flex-wrap cursor-pointer" (click)="OpenFilterCanva(content)">
                    <h6>Internet Health</h6>
                    <p class="color-0e65e9 mb-0 text-nowrap">See All</p>
                </div>
                <div>
                    <!-- <div class="form-range w-100"></div> -->
                    <div class="progress-bar-container">
                      <div class="progress-bar-background"></div>
                      <div *ngFor="let issue of host?.statistics?.internetIssues" class="progress-bar-issue"
                        [ngStyle]="{ 'left': issue.percentage + '%' }"
                      >
                        <div class="time-tooltip">
                          <p *ngIf="issue?.wanDowntime">WAN Downtime</p>
                          <div *ngIf="issue?.highLatency" class="d-flex justify-content-between flex-wrap">
                            <p class="mb-0">High Latency</p>
                            <p class="mb-0">{{ issue?.latencyAvgMs }} ms</p>
                            <p class="mb-0">{{ issue?.latencyMaxMs }} ms</p>
                          </div>
                          <p class="mb-0">{{ issue.timestamp }}</p>
                        </div>
                      </div>
                    </div>
                </div>
                <div class="d-flex align-items-center justify-content-between mt-2 border-bottom pb-3 flex-wrap">
                    <p class="color-808080 mb-0">-24</p>
                    <p class="color-808080 mb-0">Now</p>
                </div>
                <div class="d-flex align-items-center justify-content-between mt-2 flex-wrap">
                    <h6>Speed Test</h6>
                    <p class="color-0e65e9">Run Now</p>
                </div>
            </div>
        </div>

        </div>
        <div class="col-xl-9">
            <div class="row mb-3">
                <div class="col-md-12">
                    <div class="card">
                        <div class="card-body">
                            <div class="d-flex align-items-center justify-content-between flex-wrap">
                                <div>
                                    <h5 class="card-title">
                                        Hardware Information
                                    </h5>
                                </div>
                                <!-- <div class="d-flex gap-md-3 gap-2 align-items-center flex-wrap">
                                    <div class="d-flex align-items-center flex-wrap">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="#25abe9"
                                            class="bi bi-arrow-down" viewBox="0 0 16 16">
                                            <path fill-rule="evenodd"
                                                d="M8 1a.5.5 0 0 1 .5.5v11.793l3.146-3.147a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 .708-.708L7.5 13.293V1.5A.5.5 0 0 1 8 1" />
                                        </svg>
                                        <p class="mb-0 color-25abe9">0.04 Mpbs</p>
                                    </div>
                                    <div class="d-flex align-items-center flex-wrap">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="#a355ec"
                                            class="bi bi-arrow-up" viewBox="0 0 16 16">
                                            <path fill-rule="evenodd"
                                                d="M8 15a.5.5 0 0 0 .5-.5V2.707l3.146 3.147a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 1 0 .708.708L7.5 2.707V14.5a.5.5 0 0 0 .5.5" />
                                        </svg>
                                        <p class="mb-0 color-a355ec">0.04 Mpbs</p>
                                    </div>
                                    <div>
                                        <p class="color-0e65e9 mb-0 text-nowrap">See All</p>
                                    </div>
                                </div> -->
                            </div>
                            <div class="row">
                                <div class="col-md-6">
                                  <p class="mb-2 f-12"><strong>Name:</strong> {{ host?.reportedState?.hardware?.name }}</p>
                                  <p class="mb-2 f-12"><strong>Short Name:</strong> {{ host?.reportedState?.hardware?.shortname }}</p>
                                  <p class="mb-2 f-12"><strong>Serial Number:</strong> {{ host?.reportedState?.hardware?.serialno }}</p>
                                  <p class="mb-2 f-12"><strong>MAC Address:</strong> {{ host?.reportedState?.hardware?.mac }}</p>
                                  <p class="mb-2 f-12"><strong>CPU ID:</strong> {{ host?.reportedState?.hardware?.['cpu.id'] }}</p>
                                  <p class="mb-2 f-12"><strong>UUID:</strong> {{ host?.reportedState?.hardware?.uuid }}</p>
                                  <p class="mb-2 f-12"><strong>QR ID:</strong> {{ host?.reportedState?.hardware?.qrid }}</p>
                                  <p class="mb-2 f-12"><strong>Firmware Version:</strong> {{ host?.reportedState?.hardware?.firmwareVersion }}</p>
                                </div>
                                <div class="col-md-6">
                                  <p class="mb-2 f-12"><strong>Debian Codename:</strong> {{ host?.reportedState?.hardware?.debianCodename }}</p>
                                  <p class="mb-2 f-12"><strong>Hardware Revision:</strong> {{ host?.reportedState?.hardware?.hwrev }}</p>
                                  <p class="mb-2 f-12"><strong>System ID:</strong> {{ host?.reportedState?.hardware?.sysid }}</p>
                                  <p class="mb-2 f-12"><strong>Upgrade:</strong> {{ host?.reportedState?.hardware?.upgrade || 0 }}</p>
                                  <p class="mb-2 f-12"><strong>Reboot:</strong> {{ host?.reportedState?.hardware?.reboot || 0 }}</p>
                                  <p class="mb-2 f-12"><strong>UBIOS:</strong> {{ host?.reportedState?.hardware?.isUbios ? 'True' : 'False' }}</p>
                                  <p class="mb-2 f-12"><strong>BOM:</strong> {{ host?.reportedState?.hardware?.bom }}</p>
                                  <p class="mb-2 f-12"><strong>Subtype:</strong> {{ host?.reportedState?.hardware?.subtype || "N/A" }}</p>
                                </div>
                              </div>

                              <!-- End of Hardware Info -->
                            <!-- <div class="d-flex justify-content-between gap-3 mt-3 flex-wrap">
                                <div class="d-flex flex-wrap">
                                    <div>
                                        <apx-chart class="apex-charts" dir="ltr" [series]="donutChart.series" [chart]="donutChart.chart"
                                        [labels]="donutChart.labels" [legend]="donutChart.legend" [colors]="donutChart.colors"
                                        [responsive]="donutChart.responsive">
                                      </apx-chart>
                                    </div>
                                    <div>
                                        <div>
                                            <h6>Name</h6>
                                        </div>
                                        <div>
                                            <div class="d-flex align-items-center gap-2 flex-wrap mb-1">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10"
                                                    fill="gray" class="bi bi-circle-fill" viewBox="0 0 16 16">
                                                    <circle cx="8" cy="8" r="8"></circle>
                                                </svg>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                                    fill="currentColor" class="bi bi-youtube" viewBox="0 0 16 16">
                                                    <path
                                                        d="M8.051 1.999h.089c.822.003 4.987.033 6.11.335a2.01 2.01 0 0 1 1.415 1.42c.101.38.172.883.22 1.402l.01.104.022.26.008.104c.065.914.073 1.77.074 1.957v.075c-.001.194-.01 1.108-.082 2.06l-.008.105-.009.104c-.05.572-.124 1.14-.235 1.558a2.01 2.01 0 0 1-1.415 1.42c-1.16.312-5.569.334-6.18.335h-.142c-.309 0-1.587-.006-2.927-.052l-.17-.006-.087-.004-.171-.007-.171-.007c-1.11-.049-2.167-.128-2.654-.26a2.01 2.01 0 0 1-1.415-1.419c-.111-.417-.185-.986-.235-1.558L.09 9.82l-.008-.104A31 31 0 0 1 0 7.68v-.123c.002-.215.01-.958.064-1.778l.007-.103.003-.052.008-.104.022-.26.01-.104c.048-.519.119-1.023.22-1.402a2.01 2.01 0 0 1 1.415-1.42c.487-.13 1.544-.21 2.654-.26l.17-.007.172-.006.086-.003.171-.007A100 100 0 0 1 7.858 2zM6.4 5.209v4.818l4.157-2.408z" />
                                                </svg>
                                                <p class="mb-0">YouTube</p>
                                            </div>
                                            <div class="d-flex align-items-center gap-2 flex-wrap mb-1">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10"
                                                    fill="gray" class="bi bi-circle-fill" viewBox="0 0 16 16">
                                                    <circle cx="8" cy="8" r="8"></circle>
                                                </svg>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                                    fill="currentColor" class="bi bi-youtube" viewBox="0 0 16 16">
                                                    <path
                                                        d="M8.051 1.999h.089c.822.003 4.987.033 6.11.335a2.01 2.01 0 0 1 1.415 1.42c.101.38.172.883.22 1.402l.01.104.022.26.008.104c.065.914.073 1.77.074 1.957v.075c-.001.194-.01 1.108-.082 2.06l-.008.105-.009.104c-.05.572-.124 1.14-.235 1.558a2.01 2.01 0 0 1-1.415 1.42c-1.16.312-5.569.334-6.18.335h-.142c-.309 0-1.587-.006-2.927-.052l-.17-.006-.087-.004-.171-.007-.171-.007c-1.11-.049-2.167-.128-2.654-.26a2.01 2.01 0 0 1-1.415-1.419c-.111-.417-.185-.986-.235-1.558L.09 9.82l-.008-.104A31 31 0 0 1 0 7.68v-.123c.002-.215.01-.958.064-1.778l.007-.103.003-.052.008-.104.022-.26.01-.104c.048-.519.119-1.023.22-1.402a2.01 2.01 0 0 1 1.415-1.42c.487-.13 1.544-.21 2.654-.26l.17-.007.172-.006.086-.003.171-.007A100 100 0 0 1 7.858 2zM6.4 5.209v4.818l4.157-2.408z" />
                                                </svg>
                                                <p class="mb-0">YouTube</p>
                                            </div>
                                            <div class="d-flex align-items-center gap-2 flex-wrap mb-1">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10"
                                                    fill="gray" class="bi bi-circle-fill" viewBox="0 0 16 16">
                                                    <circle cx="8" cy="8" r="8"></circle>
                                                </svg>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                                    fill="currentColor" class="bi bi-facebook" viewBox="0 0 16 16">
                                                    <path
                                                        d="M16 8.049c0-4.446-3.582-8.05-8-8.05C3.58 0-.002 3.603-.002 8.05c0 4.017 2.926 7.347 6.75 7.951v-5.625h-2.03V8.05H6.75V6.275c0-2.017 1.195-3.131 3.022-3.131.876 0 1.791.157 1.791.157v1.98h-1.009c-.993 0-1.303.621-1.303 1.258v1.51h2.218l-.354 2.326H9.25V16c3.824-.604 6.75-3.934 6.75-7.951" />
                                                </svg>
                                                <p class="mb-0">Facebook</p>
                                            </div>
                                            <div class="d-flex align-items-center gap-2 flex-wrap mb-1">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10"
                                                    fill="gray" class="bi bi-circle-fill" viewBox="0 0 16 16">
                                                    <circle cx="8" cy="8" r="8"></circle>
                                                </svg>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                                    fill="currentColor" class="bi bi-cloud-fill" viewBox="0 0 16 16">
                                                    <path
                                                        d="M4.406 3.342A5.53 5.53 0 0 1 8 2c2.69 0 4.923 2 5.166 4.579C14.758 6.804 16 8.137 16 9.773 16 11.569 14.502 13 12.687 13H3.781C1.708 13 0 11.366 0 9.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383">
                                                    </path>
                                                </svg>
                                                <p class="mb-0">iCloud</p>
                                            </div>
                                        </div>
                                    </div>
                                </div> -->
                                <!-- <div class="d-flex flex-wrap gap-5">
                                    <div>
                                        <div>
                                            <h6 class="text-end">Download</h6>
                                        </div>
                                        <div>
                                            <p class="color-a355ec mb-1 text-end">3.30 MB</p>
                                            <p class="color-a355ec mb-1 text-end">23.5 MB</p>
                                            <p class="color-a355ec mb-1 text-end">5.80 MB</p>
                                            <p class="color-a355ec mb-1 text-end">43.0 MB</p>
                                        </div>
                                    </div>
                                    <div>
                                        <div>
                                            <h6 class="text-end">Upload</h6>
                                        </div>
                                        <div>
                                            <p class="color-25abe9 mb-1 text-end">138 MB</p>
                                            <p class="color-25abe9 mb-1 text-end">101 MB</p>
                                            <p class="color-25abe9 mb-1 text-end">104 MB</p>
                                            <p class="color-25abe9 mb-1 text-end">36.4 MB</p>
                                        </div>
                                    </div>

                                    <div>
                                        <div>
                                            <h6 class="text-end">Total</h6>
                                        </div>
                                        <div>
                                            <p class="mb-1 text-end">141 MB</p>
                                            <p class="mb-1 text-end">124 MB</p>
                                            <p class="mb-1 text-end">110 MB</p>
                                            <p class="mb-1 text-end">18.6 MB</p>
                                        </div>
                                    </div>
                                </div>
                            </div> -->
                        </div>
                    </div>
                </div>

            </div>
            <div class="row mb-3">
                <div class="col-md-12">
                    <div class="card">
                        <div class="card-body">
                            <div class="d-flex align-items-center justify-content-between">
                                <div>
                                    <h5 class="card-title">WiFi Technology</h5>
                                </div>
                                <div>
                                    <p class="color-0e65e9 mb-0 text-nowrap">See All</p>
                                </div>
                            </div>
                            <!-- d-flex justify-content-between gap-3 flex-wrap  -->
                            <div class="mt-3">
                                <div *ngIf="wifiCount">
                                    <apx-chart class="apex-charts" dir="ltr" [series]="wifiCount.series" [chart]="wifiCount.chart"
                                        [labels]="wifiCount.labels" [legend]="wifiCount.legend" [colors]="wifiCount.colors"
                                        [responsive]="wifiCount.responsive">
                                    </apx-chart>
                                </div>

                                <!-- <div class="d-flex flex-wrap gap-5"> -->
                                <!-- <div>
                                    <h6>Type</h6>
                                    <div class="d-flex align-items-center gap-2 mb-2">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" fill="gray"
                                            class="bi bi-circle-fill" viewBox="0 0 16 16">
                                            <circle cx="8" cy="8" r="8"></circle>
                                        </svg>
                                        <div class="d-flex align-items-center">
                                            <p class="mb-0 border-end pe-2">
                                                WiFi 5
                                            </p>
                                            <p class="mb-0 ps-2">5 GHz</p>
                                        </div>
                                    </div>
                                    <div class="d-flex align-items-center gap-2 mb-2">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" fill="gray"
                                            class="bi bi-circle-fill" viewBox="0 0 16 16">
                                            <circle cx="8" cy="8" r="8"></circle>
                                        </svg>
                                        <div class="d-flex align-items-center">
                                            <p class="mb-0 border-end pe-2">
                                                WiFi 5
                                            </p>
                                            <p class="mb-0 ps-2">5 GHz</p>
                                        </div>
                                    </div>
                                    <div class="d-flex align-items-center gap-2 mb-2">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" fill="gray"
                                            class="bi bi-circle-fill" viewBox="0 0 16 16">
                                            <circle cx="8" cy="8" r="8"></circle>
                                        </svg>
                                        <div class="d-flex align-items-center">
                                            <p class="mb-0 border-end pe-2">
                                                WiFi 5
                                            </p>
                                            <p class="mb-0 ps-2">5 GHz</p>
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <h6>Activity</h6>
                                    <div>
                                        <div class="activity-rang w-100 mt-3 mb-4"></div>
                                        <div class="activity-rang w-100 mt-3 mb-4"></div>
                                        <div class="activity-rang w-100 mt-3"></div>
                                    </div>
                                </div>
                                <div>
                                    <h6>Experience</h6>
                                    <div>
                                        <p class="color-6bd700  mb-2 text-end">Excellent</p>
                                        <p class="color-6bd700  mb-2 text-end">Excellent</p>
                                        <p class="color-6bd700  mb-2 text-end">Excellent</p>
                                    </div>
                                </div>
                                <div>
                                    <h6>Connections</h6>
                                    <div>
                                        <p class="mb-2 text-end">9</p>
                                        <p class="mb-2 text-end">3</p>
                                        <p class="mb-2 text-end">9</p>
                                    </div>
                                </div> -->
                                <!-- </div> -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row mb-3">
                <div class="col-md-12">
                    <div class="card">
                        <div class="card-body">
                            <div class="d-flex align-items-center justify-content-between mb-2">
                                <h5 class="card-title">Most Active Devices</h5>
                                <p class="color-0e65e9 mb-0 text-nowrap">See All</p>
                            </div>
                            <div class="d-flex align-items-center gap-3 flex-wrap">
                                <p *ngIf="devices.length === 0">N/A</p>
                                <div class="d-flex align-items-center flex-column" *ngFor="let device of devices">
                                    <div class="smart-phone-main border-secondary p-2">
                                        <!-- <img src="assets/images/network-overview-img/smartphone.png" alt="" /> -->
                                        <i class="fa-solid fa-router fs-4"></i>
                                    </div>
                                    <p class="mb-0 f-12">{{ device.name }}</p>
                                    <p class="mb-0 f-12">
                                        Status: {{ device.status | titlecase }}
                                        <span
                                            class="udm-li disconnected"
                                            [ngClass]="{ 'connected': device.status == 'online' }"
                                        ></span>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- <div class="row mb-3">
                <div class="col-md-12">
                    <div class="card">
                        <div class="card-body">
                            <div class="d-flex align-items-center justify-content-between mb-2">
                                <h5 class="card-title">Most Active Access Points</h5>
                                <p class="color-0e65e9 mb-0 text-nowrap">See All</p>
                            </div>
                            <div class="d-flex align-items-center gap-3 flex-wrap">
                                <div class="d-flex align-items-center flex-column">
                                    <div class="smart-phone-main border-primary p-2">
                                        <img src="assets/images/network-overview-img/smartphone.png" alt="" />
                                    </div>
                                    <p class="mb-0 f-12">Cafe-Verde</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div> -->

            <!-- <div class="row mb-4">
                <div class="col-md-12">
                    <div class="card">
                        <div class="card-body">
                            <div class="d-flex align-items-center justify-content-between mb-2">
                                <h5 class="card-title">Active Channels</h5>
                                <p class="color-0e65e9 mb-0 text-nowrap">See All</p>
                            </div>
                            <div class="row">
                                <div class="col-md-6 f-12">2.4GHz</div>
                                <div class="col-md-3 f-12">5GHz</div>
                            </div>

                           <div class="d-flex align-items-center gap-2 flex-wrap">
                                <div class="text-center">

                                    <div class="slider-bar bg-bababe"></div>
                                    <span class="f-12">1</span>
                                </div>
                                <div class="text-center">
                                    <div class="slider-bar bg-bababe"></div>
                                    <span class="f-12">2</span>
                                </div>
                                <div class="text-center">
                                    <div class="slider-bar bg-bababe"></div>
                                    <span class="f-12">3</span>
                                </div>
                                <div class="text-center">
                                    <div class="slider-bar bg-bababe"></div>
                                    <span class="f-12">4</span>
                                </div>
                                <div class="text-center">
                                    <div class="slider-bar bg-bababe"></div>
                                    <span class="f-12">5</span>
                                </div>
                                <div class="text-center">
                                    <div class="slider-bar bg-28a745"></div>
                                    <span class="f-12">6</span>
                                </div>
                                <div class="text-center">
                                    <div class="slider-bar bg-bababe"></div>
                                    <span class="f-12">7</span>
                                </div>
                                <div class="text-center">
                                    <div class="slider-bar bg-bababe"></div>
                                    <span class="f-12">8</span>
                                </div>
                                <div class="text-center">
                                    <div class="slider-bar bg-bababe"></div>
                                    <span class="f-12">9</span>
                                </div>
                                <div class="text-center">
                                    <div class="slider-bar bg-bababe"></div>
                                    <span class="f-12">10</span>
                                </div>
                                <div class="text-center">
                                    <div class="slider-bar bg-bababe"></div>
                                    <span class="f-12">11</span>
                                </div>
                                <div class="text-center">
                                    <div class="slider-bar bg-bababe"></div>
                                    <span class="f-12">36</span>
                                </div>
                                <div class="text-center">
                                    <div class="slider-bar bg-bababe"></div>
                                    <span class="f-12">40</span>
                                </div>
                                <div class="text-center">
                                    <div class="slider-bar bg-28a745"></div>
                                    <span class="f-12">44</span>
                                </div>
                                <div class="text-center">
                                    <div class="slider-bar bg-bababe"></div>
                                    <span class="f-12">48</span>
                                </div>
                                <div class="text-center">
                                    <div class="slider-bar bg-bababe"></div>
                                    <span class="f-12">52</span>
                                </div>
                                <div class="text-center">
                                    <div class="slider-bar bg-bababe"></div>
                                    <span class="f-12">56</span>
                                </div>
                                <div class="text-center">
                                    <div class="slider-bar bg-bababe"></div>
                                    <span class="f-12">60</span>
                                </div>
                                <div class="text-center">
                                    <div class="slider-bar bg-bababe"></div>
                                    <span class="f-12">64</span>
                                </div>
                                <div class="text-center">
                                    <div class="slider-bar bg-bababe"></div>
                                    <span class="f-12">100</span>
                                </div>
                                <div class="text-center">
                                    <div class="slider-bar bg-bababe"></div>
                                    <span class="f-12">104</span>
                                </div>
                                <div class="text-center">
                                    <div class="slider-bar bg-bababe"></div>
                                    <span class="f-12">108</span>
                                </div>
                                <div class="text-center">
                                    <div class="slider-bar bg-bababe"></div>
                                    <span class="f-12">112</span>
                                </div>
                                <div class="text-center">
                                    <div class="slider-bar bg-bababe"></div>
                                    <span class="f-12">116</span>
                                </div>
                                <div class="text-center">
                                    <div class="slider-bar bg-bababe"></div>
                                    <span class="f-12">120</span>
                                </div>
                                <div class="text-center">
                                    <div class="slider-bar bg-bababe"></div>
                                    <span class="f-12">124</span>
                                </div>
                                <div class="text-center">
                                    <div class="slider-bar bg-bababe"></div>
                                    <span class="f-12">128</span>
                                </div>
                                <div class="text-center">
                                    <div class="slider-bar bg-bababe"></div>
                                    <span class="f-12">132</span>
                                </div>
                                <div class="text-center">
                                    <div class="slider-bar bg-bababe"></div>
                                    <span class="f-12">136</span>
                                </div>
                                <div class="text-center">
                                    <div class="slider-bar bg-bababe"></div>
                                    <span class="f-12">140</span>
                                </div>
                                <div class="text-center">
                                    <div class="slider-bar bg-bababe"></div>
                                    <span class="f-12">144</span>
                                </div>
                                <div class="text-center">
                                    <div class="slider-bar bg-bababe"></div>
                                    <span class="f-12">149</span>
                                </div>
                                <div class="text-center">
                                    <div class="slider-bar bg-bababe"></div>
                                    <span class="f-12">153</span>
                                </div>
                                <div class="text-center">
                                    <div class="slider-bar bg-bababe"></div>
                                    <span class="f-12">157</span>
                                </div>
                                <div class="text-center">
                                    <div class="slider-bar bg-bababe"></div>
                                    <span class="f-12">165</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div> -->

            <div class="row">
                <div class="col-md-12">
                    <div class="card">
                        <div class="card-body">
                            <div>
                                <div class="d-flex align-items-center justify-content-between mb-2 flex-wrap">
                                    <div>
                                        <h5 class="card-title">Location</h5>
                                    </div>
                                </div>
                                <p class="f-12">{{ host?.reportedState?.location?.text }}</p>
                            </div>
                            <ng-container *ngIf="host?.reportedState?.location?.lat && host?.reportedState?.location?.long">
                                <agm-map [latitude]="host?.reportedState?.location?.lat" [longitude]="host?.reportedState?.location?.long" [zoom]="16" [disableDefaultUI]="false"
                                [streetViewControl]="false">
                                <agm-marker [latitude]="host?.reportedState?.location?.lat" [markerDraggable]="false" [longitude]="host?.reportedState?.location?.long"
                                ></agm-marker>
                            </agm-map>
                            </ng-container>
                            <!-- <div class="column-chart">
                                <apx-chart class="apex-charts" dir="ltr" [series]="splineAreaChart.series" [chart]="splineAreaChart.chart"
            [dataLabels]="splineAreaChart.dataLabels" [stroke]="splineAreaChart.stroke"
            [colors]="splineAreaChart.colors" [xaxis]="splineAreaChart.xaxis" [grid]="splineAreaChart.grid"
            [tooltip]="splineAreaChart.tooltip"></apx-chart>
                            </div> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


<div>
    <ng-template #content let-offcanvas>
        <div class="card-popup">
            <div class="card-header d-flex justify-content-center align-items-center flex-wrap position-relative">
              <div class="text-center">Comcast Cable</div>
             <div class="position-absolute cable-colse-icon">
                <button
                type="button"
                class="btn-close"
                aria-label="Close"
                (click)="offcanvas.dismiss('Cross click')"
              ></button>
             </div>
            </div>
           <div class="tab-header">
            <div class="tab-new ">
               <ul class="nav nav-pills justify-content-between">
                  <li class="nav-item w-50">
                     <button (click)="selectTab(1)" class="nav-link text-center w-100" [class.active]="selectedTab === 1"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#3579a7" class="bi bi-bar-chart-line tab-icon iconactive" viewBox="0 0 16 16">
                      <path d="M11 2a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v12h.5a.5.5 0 0 1 0 1H.5a.5.5 0 0 1 0-1H1v-3a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v3h1V7a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v7h1zm1 12h2V2h-2zm-3 0V7H7v7zm-5 0v-3H2v3z"/>
                    </svg></button>
                   </li>
                  <li class="nav-item w-50">
                    <button (click)="selectTab(2)" class="nav-link text-center w-100" [class.active]="selectedTab === 2"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#b8b4b4" class="bi bi-bar-chart-line iconactive" viewBox="0 0 16 16">
                     <path d="M11 2a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v12h.5a.5.5 0 0 1 0 1H.5a.5.5 0 0 1 0-1H1v-3a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v3h1V7a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v7h1zm1 12h2V2h-2zm-3 0V7H7v7zm-5 0v-3H2v3z"/>
                   </svg></button>
                  </li>

                </ul>
            </div>
           </div>
           <div class="tabs-container">
            <div class="card-body" *ngIf="selectedTab === 1">
                <ul class="list-group">
                  <li class="list-group-item d-flex justify-content-between flex-wrap">
                    <span class="fs-6 changefont">WAN IP (Port 5)</span>
                    <span class="text-secondary fs-6 changefont">10.1.10.25</span>
                  </li>
                  <li class="list-group-item d-flex justify-content-between flex-wrap">
                    <span class="fs-6 changefont">Gateway IP</span>
                    <span class="text-secondary fs-6 changefont">10.10.0.1</span>
                  </li>
                  <li class="list-group-item d-flex justify-content-between flex-wrap">
                    <span class="fs-6 changefont">Latency</span>
                    <span class="text-secondary fs-6 changefont">12 ms</span>
                  </li>
                  <li class="list-group-item d-flex justify-content-between flex-wrap">
                    <span class="fs-6 changefont">Service Provider</span>
                    <span class="text-secondary fs-6 changefont">Comcast Cable</span>
                  </li>
                  <li class="list-group-item d-flex justify-content-between flex-wrap">
                    <span class="fs-6 changefont">Location</span>
                    <span class="text-secondary fs-6 changefont">Saratoga</span>
                  </li>
                  <li class="list-group-item d-flex justify-content-between flex-wrap">
                    <span class="fs-6 changefont">Download Capacity</span>
                    <span class="text-secondary fs-6 changefont">350 Mbps</span>
                  </li>
                  <li class="list-group-item d-flex justify-content-between flex-wrap">
                    <span class="fs-6 changefont">Upload Capacity</span>
                    <span class="text-secondary fs-6 changefont">32.0 Mbps</span>
                  </li>
                  <li class="list-group-item d-flex justify-content-between flex-wrap">
                    <span class="fs-6 changefont">Uptime</span>
                    <span class="text-secondary fs-6 changefont">100%</span>
                  </li>
                  <li class="list-group-item d-flex justify-content-between flex-wrap">
                    <span class="fs-6 changefont">Peak Utilization</span>
                    <span class="text-secondary fs-6 changefont">0% / 0%</span>
                  </li>
                </ul>
                <div class="mt-4 Quality-main">

                  <div class="accordion" id="accordionPanelsStayOpenExample">
                      <div class="accordion-item">
                        <h2 class="accordion-header">
                          <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseOne" aria-expanded="true" aria-controls="panelsStayOpen-collapseOne">
                              <h6 class="f-15">Internet Quality</h6>
                          </button>
                        </h2>
                        <div id="panelsStayOpen-collapseOne" class="accordion-collapse collapse show">
                          <div class="accordion-body">
                              <apx-chart class="apex-charts" dir="ltr" [series]="splineAreaChart.series" [chart]="splineAreaChart.chart"
                              [dataLabels]="splineAreaChart.dataLabels" [stroke]="splineAreaChart.stroke"
                              [colors]="splineAreaChart.colors" [xaxis]="splineAreaChart.xaxis" [grid]="splineAreaChart.grid"
                              [tooltip]="splineAreaChart.tooltip"></apx-chart>
                          </div>
                        </div>
                      </div>
                    </div>


                  </div>

                <div class="mt-4 mb-4 Quality-main">
                  <div class="accordion" id="accordionPanelsStayOpenExample">
                      <div class="accordion-item">
                        <h2 class="accordion-header">
                          <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseThree" aria-expanded="false" aria-controls="panelsStayOpen-collapseThree">
                              <h6 class="f-15">Internet Event Logs</h6>
                          </button>
                        </h2>
                        <div id="panelsStayOpen-collapseThree" class="accordion-collapse collapse">
                          <div class="accordion-body">
                              <div class="d-flex gap-3 align-items-center">
                                  <div class="internet-img">

                                  </div>
                                  <div>
                                      <p class="mb-0 month-font">Internet Disconnected </p>
                                      <p  class="mb-0 month-font"> <span class="pe-2 month-font">Sep 02, 01:42:17 AM</span> <span class="ps-2 month-font" style="border-left: 1px solid #808080;">2m 22s</span></p>
                                  </div>
                              </div>
                          </div>
                        </div>
                      </div>
                    </div>
                </div>
              </div>
              <div *ngIf="selectedTab === 2" >

              </div>
           </div>


        </div>



      </ng-template>
</div>
























